import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useRef, useState } from 'react';
import SimpleBar from 'simplebar-react';
import Records from './schema/Records';

const Schemas = (props: any) => {
  // const kartes = props.kartes || null;
  const [view, setView] = useState(false);
  const childRef = useRef<any>();

  const handleView = () => {
    setView(!view);
  };

  return (
    <Stack
      width={'100%'}
      className={`${view ? 'showAll' : 'showLess'}`}
      sx={{
        backgroundColor: 'primary.light',
        '& .simplebar-track.simplebar-vertical .simplebar-scrollbar:before': {
          backgroundColor: '#CCD1D9',
        },
        '&.showAll .simplebar-root': { maxHeight: 'max-content !important' },
        '&.showLess .simplebar-root': { maxHeight: '234px !important' },
      }}
      borderTop={'4px solid #FFCE54'}
      mb={'16px'}
    >
      <Stack
        direction={'row'}
        justifyContent={'space-between'}
        alignItems={'center'}
        p={'5px 16px'}
        height={'48px'}
      >
        <Typography fontSize={'14px'} fontWeight={700}>
          カルテ
        </Typography>
        <Stack direction={'row'} spacing={'8px'}>
          <Box
            component={'img'}
            src={`/images/icons/ic-arrow-${view ? 'up' : 'down'}.svg`}
            alt='edit'
            sx={{ cursor: 'pointer' }}
            width={'24px'}
            onClick={handleView}
          />
          <Box
            component={'img'}
            src='/images/icons/ic-plus.svg'
            alt='edit'
            sx={{ cursor: 'pointer' }}
            width={'24px'}
            onClick={() => childRef?.current?.handleCreateTemplate()}
          />
          <Box
            component={'img'}
            src='/images/icons/ic-drag-drop.svg'
            alt='edit'
            sx={{ cursor: 'pointer' }}
            width={'24px'}
          />
        </Stack>
      </Stack>
      <SimpleBar style={{ maxHeight: '234px' }} className='simplebar-root'>
        <Records ref={childRef} />
      </SimpleBar>
    </Stack>
  );
};

export default Schemas;
